import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, WHATSAPP } from "@/lib/api";
import { Mail, MapPin, Phone } from "lucide-react";

export default function Contacto() {
  const [form, setForm] = useState({ nombre: "", email: "", telefono: "", mensaje: "" });
  const [turno, setTurno] = useState({ nombre: "", dni: "", telefono: "", motivo: "", fecha: "", hora: "" });
  const [slots, setSlots] = useState([]);

  useEffect(() => { api.get("/slots").then((r) => setSlots(r.data)).catch(() => {}); }, []);

  const enviar = async (e) => {
    e.preventDefault();
    try {
      await api.post("/contact", form);
      setForm({ nombre: "", email: "", telefono: "", mensaje: "" });
      toast.success("Mensaje enviado. Te responderé a la brevedad.");
    } catch (err) { toast.error(errMsg(err)); }
  };

  const pedirTurno = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/appointments", turno);
      toast.success("Solicitud registrada. Se abrirá WhatsApp para confirmar.");
      window.open(data.whatsapp_url, "_blank");
    } catch (err) { toast.error(errMsg(err)); }
  };

  const inp = "w-full border border-[#dcd5ce] bg-white px-4 py-3 text-sm outline-none focus:border-[#c5a059]";

  return (
    <div data-testid="contacto-page" className="mx-auto max-w-7xl px-6 py-24">
      <p className="label-xs">Contacto</p>
      <h1 className="mt-4 max-w-3xl text-5xl tracking-tight sm:text-6xl">Escribime o solicitá tu turno</h1>

      <div className="mt-14 grid gap-14 lg:grid-cols-[1fr_1fr]">
        <div>
          <div className="space-y-5 text-sm text-[#4a4744]">
            <p className="flex items-center gap-3"><MapPin size={16} className="text-[#c5a059]" /> Necochea, Provincia de Buenos Aires, Argentina</p>
            <p className="flex items-center gap-3"><Mail size={16} className="text-[#c5a059]" /> licroppeldaniela@hotmail.com</p>
            <p className="flex items-center gap-3"><Phone size={16} className="text-[#c5a059]" /> 02262-484516</p>
            <a href={WHATSAPP} target="_blank" rel="noreferrer" data-testid="contacto-whatsapp" className="inline-block btn-gold rounded-full px-8 py-3.5 text-xs font-semibold uppercase tracking-[0.18em]">
              Escribir por WhatsApp
            </a>
          </div>

          <form onSubmit={enviar} className="mt-12 space-y-4 border-t border-[#dcd5ce] pt-10">
            <h2 className="text-3xl">Mensaje</h2>
            <input data-testid="contacto-nombre" required placeholder="Nombre y apellido" className={inp} value={form.nombre} onChange={(e) => setForm({ ...form, nombre: e.target.value })} />
            <input data-testid="contacto-email" placeholder="Email" className={inp} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
            <input data-testid="contacto-telefono" placeholder="Teléfono" className={inp} value={form.telefono} onChange={(e) => setForm({ ...form, telefono: e.target.value })} />
            <textarea data-testid="contacto-mensaje" required rows={4} placeholder="Contame en qué puedo ayudarte" className={inp} value={form.mensaje} onChange={(e) => setForm({ ...form, mensaje: e.target.value })} />
            <button data-testid="contacto-enviar" className="btn-gold rounded-full px-8 py-3.5 text-xs font-semibold uppercase tracking-[0.18em]">Enviar mensaje</button>
          </form>
        </div>

        <form onSubmit={pedirTurno} className="card-nilo space-y-4 p-10" data-testid="turno-form">
          <p className="label-xs">Agenda</p>
          <h2 className="text-3xl">Solicitud de turno</h2>
          <p className="text-sm text-[#5e5a56]">Elegí un día y horario disponible. La profesional confirma cada turno por WhatsApp.</p>
          <input data-testid="turno-nombre" required placeholder="Nombre y apellido" className={inp} value={turno.nombre} onChange={(e) => setTurno({ ...turno, nombre: e.target.value })} />
          <input data-testid="turno-dni" placeholder="DNI" className={inp} value={turno.dni} onChange={(e) => setTurno({ ...turno, dni: e.target.value })} />
          <input data-testid="turno-telefono" placeholder="Teléfono / WhatsApp" className={inp} value={turno.telefono} onChange={(e) => setTurno({ ...turno, telefono: e.target.value })} />
          {slots.length > 0 ? (
            <select data-testid="turno-slot" required className={inp} value={turno.fecha ? `${turno.fecha}|${turno.hora}` : ""}
              onChange={(e) => { const [f, h] = e.target.value.split("|"); setTurno({ ...turno, fecha: f, hora: h }); }}>
              <option value="">Seleccionar disponibilidad</option>
              {slots.map((s) => <option key={s.id} value={`${s.fecha}|${s.hora}`}>{s.fecha} — {s.hora} hs</option>)}
            </select>
          ) : (
            <div className="grid grid-cols-2 gap-4">
              <input data-testid="turno-fecha" required type="date" className={inp} value={turno.fecha} onChange={(e) => setTurno({ ...turno, fecha: e.target.value })} />
              <input data-testid="turno-hora" required type="time" className={inp} value={turno.hora} onChange={(e) => setTurno({ ...turno, hora: e.target.value })} />
            </div>
          )}
          <textarea data-testid="turno-motivo" rows={3} placeholder="Motivo de consulta" className={inp} value={turno.motivo} onChange={(e) => setTurno({ ...turno, motivo: e.target.value })} />
          <button data-testid="turno-enviar" className="btn-gold w-full rounded-full px-8 py-3.5 text-xs font-semibold uppercase tracking-[0.18em]">Solicitar turno por WhatsApp</button>
        </form>
      </div>
    </div>
  );
}
